import {Module} from "vuex"
import {RooteState} from "@/store/index";

export interface CommonModalState{
  type: string
  isOpen: boolean
  html: string
  title: string
  confirm: () => void
}

const initialState: CommonModalState = {
  type: "",
  isOpen: false,
  html: "",
  title: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  confirm: () => {},
}

export const commonModal: Module<CommonModalState, RooteState> = {
  namespaced: true,
  state: () => ({
    ...initialState
  }),
  mutations: {
    setOpen(state, payload: CommonModalState) {
      state.type = payload.type;
      state.isOpen = true;
      state.html = payload.html;
      state.title = payload.title;
      state.confirm = payload.confirm;
    },
    setClose(state) {
      Object.assign(state, { ...initialState });
    }
  },
  actions: {
    openModal({ commit }, payload: CommonModalState) {
      commit('setOpen', payload);
    },
    closeModal({ commit }) {
      commit('setClose');
    }
  },
  getters: {
    isModalOpen: (state) => state.isOpen,
    modalType: (state) => state.type,
    modalHTML: (state) => state.html,
    modalTitle: (state) => state.title,
  }
}